import { useState, useContext } from 'react';
import papaparse from 'papaparse';
import lodash from 'lodash';
import { AppContext, EMPTY_STRING } from 'commons-ui';
import { useHistory } from 'react-router-dom';
import useService from '../utils/useService';
import { prepareMagicBoxSchedule, actionOptions, EMagicBoxDropDownOptions, EApiResponseStatus } from '../utils';
import { IMagicBoxSchedule, IActionOptions, ICsvToJson, ParsedData } from '../model';

const useUpload = () => {
	const [csvFile, setCSVFile] = useState<File | null>(null);
	const [showLoader, setShowLoader] = useState(false);
	const [selectedAction, setSelectedAction] = useState([actionOptions[0]]);
	const { app, showAlert } = useContext(AppContext);
	const { requestCreateMagicBoxSchedule, requestRemoveMagicBoxSchedule } = useService();
	const history = useHistory();

	const handleActionChange = (value: IActionOptions[]): void => {
		setSelectedAction(value);
	};

	const handleFileUpload = async (uploadedFiles: File[]): Promise<void> => {
		const file = lodash.first(uploadedFiles);
		if (!lodash.isEmpty(file)) await setCSVFile(file);
	};

	const CSVtoJSON = (csvText: string): ParsedData => {
		const parsedData = papaparse.parse(csvText, { header: true, skipEmptyLines: true });
		return parsedData.data as ParsedData;
	};

	const createMagicBoxSchedule = async (jsonData: ICsvToJson[]): Promise<void> => {
		if (!jsonData) return;
		setShowLoader(true);
		let resp;
		if (selectedAction?.[0]?.id === EMagicBoxDropDownOptions.REMOVE) {
			resp = await requestRemoveMagicBoxSchedule(app.appName, jsonData[0]?.magicBoxScheduleId);
		} else {
			const magicBoxSchedule: IMagicBoxSchedule = prepareMagicBoxSchedule(jsonData);
			resp = await requestCreateMagicBoxSchedule(app.appName, magicBoxSchedule);
		}
		if (resp?.data?.success) showAlert('CSV upload successfully.', { type: EApiResponseStatus.SUCCESS });
		else
			showAlert(resp?.data?.externalMessage || 'some error ocurred while uploading csv', {
				type: EApiResponseStatus.ERROR,
				duration: 'MEDIUM'
			});
		history.goBack();
	};

	const uploadCsvFile = (): void => {
		if (!csvFile) return;

		const reader = new FileReader();
		reader.onload = () => {
			const text: string = reader.result?.toString() || EMPTY_STRING;
			const data = CSVtoJSON(text);
			createMagicBoxSchedule(data);
		};
		reader.readAsText(csvFile);
	};

	return {
		showLoader,
		showAlert,
		csvFile,
		selectedAction,
		handleFileUpload,
		uploadCsvFile,
		handleActionChange
	};
};

export default useUpload;
